module.exports = __webpack_public_path__ + "static/media/profesional-active.949789f0.svg";